<template>
    <ul
        v-if="files && files.length"
        class="file-list"
    >
        <li
            v-for="(file, index) in files"
            :key="index"
        >
            <BaseIcon
                class="dn-icon--square"
                :icon="`file-${iconSuffix(file)}`"
            />

            <a
                :href="file.url"
                target="_blank"
                rel="noopener"
            >
                {{ file.title }}
            </a>
        </li>
    </ul>
</template>

<script setup>
defineProps({
    files: {
        type: Array,
        required: false,
        default: null
    }
});

const iconSuffix = (file) => {
    if (file.mimeType === 'application/pdf') {
        return 'pdf';
    }

    return 'generic';
};
</script>

<style lang="less">
.file-list {
    .list-clean;

    li {
        display: flex;
        align-items: flex-start;
    }

    li + li {
        margin-top: 1rem;

        @media @q-lg-min {
            margin-top: 1.5rem;
        }
    }

    .dn-icon {
        font-size: 1.25em;
        line-height: 1.5rem;
        margin-right: .25rem;
    }

    a {
        color: var(--color-text);
        text-decoration: underline;
        transition: color var(--transition-fast);

        &:hover, &:focus {
            color: var(--color-primary);
        }

        &:active {
            color: var(--color-primary-dark);
        }
    }
}
</style>
